module.exports = __webpack_public_path__ + "img/house.1c32499f.svg";